import { trackPromise } from 'react-promise-tracker';
import constants from './constants';
import { sendSecureMessageApi } from '../../services/secureMessageService';

export const sendSecureMessageBegin = payload => ({
    type: constants.SEND_SECURE_MESSAGE_BEGIN,
    payload,
});

export const sendSecureMessageSuccess = payload => ({
    type: constants.SEND_SECURE_MESSAGE_SUCCESS,
    payload,
});
export const sendSecureMessageCleanUp = () => ({
    type: constants.SEND_SECURE_MESSAGE_CLEANUP,
});

export const sendSecureMessaageError = payload => ({
    type: constants.SEND_SECURE_MESSAGE_ERROR,
    payload
});

export const sendSecureMessage = (membersDetail, topic, userMessage, tenantId) => {
    return (dispatch) => {
        dispatch(sendSecureMessageBegin());
        trackPromise(sendSecureMessageApi(membersDetail, topic, userMessage, tenantId)
            .then((response) => {
                dispatch(sendSecureMessageSuccess(response));
            })
            .catch((error) => dispatch(sendSecureMessaageError(error))));
    };
};
